import React, { Component } from 'react';
import { Example } from 'examples';
import Group from '../Group/Group';
import Icon, { ICONS } from '../Icon/Icon';
import Input from '../Input/Input';
import Slider from '../Slider/Slider';

const MIN_ICON_SIZE = 1;

export default class IconExample extends Component {

  state = {
    iconSize: 0.154,
    value: '',
  };

  onChange = e => {
    const value = e.target.value.toLowerCase() || '';
    const children = this.refList.children;

    for (let i = 0; i < children.length; i++) {
      const attr = children[i].getAttribute('data-name');
      let visible = false;

      if (value.length === 0 || attr.indexOf(value) >= 0) {
        visible = true;
      }
      children[i].style.display = visible ? 'block' : 'none';
    }
    this.setState({ value: e.target.value });
  };

  onIconChange = e => this.setState({ iconSize: e.target.value });

  getIconName = name => {
    const brandIcons = {
      'data': 1,
      'io': 1,
      'live-lcp': 1,
      'profiles': 1,
      'monetise': 1,
      'orchestrate': 1,
      'via': 1
    }
    return brandIcons[name] ? `${name}-brand` : name
  }

  render() {
    const size = this.state.iconSize ? this.state.iconSize * 11 + MIN_ICON_SIZE : MIN_ICON_SIZE;
    const rems = `${size}rem`;
    const icons = ICONS.map(name =>
      <li key={name} data-name={this.getIconName(name)}>
        <h3>{name}</h3>
        <Icon name={name} style={{
          width: rems,
          height: rems,
        }}/>
      </li>);

    return (
      <Example {...this.props} className="no-props">
        <Group className="toolbar">
          <Input onChange={this.onChange} placeholder="Search bundled icon names" value={this.state.value}/>
          <div className="slider-wrapper">
            <Slider value={this.state.iconSize} onChange={this.onIconChange}/>
            <span className="rem">{`${parseFloat(size).toFixed(2)}rem`}</span>
          </div>
        </Group>
        <ul className="icons" ref={c => { this.refList = c; }}>
          {icons}
        </ul>
      </Example>
    );
  }

}
